import { render, staticRenderFns } from "./changeName.vue?vue&type=template&id=2b8838de&scoped=true"
import script from "./changeName.vue?vue&type=script&lang=js"
export * from "./changeName.vue?vue&type=script&lang=js"
import style0 from "./changeName.vue?vue&type=style&index=0&id=2b8838de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8838de",
  null
  
)

export default component.exports